import OrderMsg from './OrderMsg';

export default OrderMsg;
